// import React, { useEffect, useState, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import { io } from 'socket.io-client';
// import { Box, Flex, Spinner, Image, Text, Heading, Stack, Alert, AlertIcon, Grid, GridItem, Container, Badge } from '@chakra-ui/react';
// import Api from '../../api/ApiUrl';

// const SOCKET_URL = `${Api}/auctiondetails`;
// const socket = io(SOCKET_URL, {
//   autoConnect: false
// });

// const AuctionComponent = () => {s
//   const { id: subcategoryId } = useParams();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [timeLeft, setTimeLeft] = useState('');

//   const timerRef = useRef(null);

//   const calculateTimeLeft = (endDate) => {
//     const now = new Date().getTime();
//     const endTime = new Date(endDate).getTime();
//     const timeRemaining = endTime - now;

//     const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

//     setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
//   };

//   useEffect(() => {
//     socket.on('connect', () => {
//       socket.emit('getSubcategoryData', { subcategoryId });
//     });

//     socket.on('subCategoryDatachanged', () => {
//       socket.emit('getSubcategoryData', { subcategoryId });
//     });

//     socket.on('auctionData', (data) => {
//       setData(data);
//       setLoading(false);

//       calculateTimeLeft(data.endDate);

//       timerRef.current = setInterval(() => {
//         calculateTimeLeft(data.endDate);
//       }, 1000);
//     });

//     socket.on('error', (error) => {
//       setError(error);
//       setLoading(false);
//     });

//     socket.connect();

//     return () => {
//       socket.disconnect();
//       clearInterval(timerRef.current);
//     };
//   }, [subcategoryId]);

//   if (loading) {
//     return <Flex justify="center" align="center" height="100vh" bg="gray.800" color="white"><Spinner size="xl" /></Flex>;
//   }

//   if (error) {
//     return <Alert status="error" bg="red.700" color="white"><AlertIcon />{error.message || 'Error loading data'}</Alert>;
//   }

//   if (!data) {
//     return <Alert status="warning" bg="yellow.700" color="white"><AlertIcon />No data available</Alert>;
//   }

//   const isAuctionEnded = new Date() > new Date(data.endDate);
// console.log(data)
//   return (
//     <Box color="black" minHeight="100vh" py={10} position="relative">
//       <Box position="absolute" top="40%" left="55%" transform="translate(-50%, -50%)" opacity="0.1" fontSize="10rem" fontWeight="bold" zIndex={0}>
//         <Text as="span" color="red">Mazadat</Text><Text as="span" color="black"> Masr</Text>
//       </Box>

//       <Container maxW="container.xl" zIndex={1}>
//         <Heading as="h1" mb={8} textAlign="center" color="teal.300">Auction Details</Heading>
//         <Box mb={8} p={5} shadow="md" borderWidth="1px" borderRadius="lg">
//           <Image src={`${Api}/${data.imagecover.path}`} alt={data.name} borderRadius="md" />
//           <Text fontSize="2xl" mt={4} color="teal.200">{data.name}</Text>
//           <Text mt={2}>{data.description}</Text>
//           <Text mt={2}>Start Date: {new Date(data.startDate).toLocaleString()}</Text>
//           <Text mt={2}>End Date: {new Date(data.endDate).toLocaleString()}</Text>
//           {!isAuctionEnded && (
//             <>
//               <Text mt={2}>Total Bid Count: {data.totalBidCount}</Text>
//               <Text mt={2}>Total Deposit Users Count: {data.totalDepositUsersCount}</Text>
//               <Text mt={2}>Total Bid Users Count: {data.totalBidUsersCount}</Text>
//               <Text mt={2}>Time Remaining: {timeLeft}</Text>
//             </>
//           )}
//         </Box>
  
//           <>
//             <Heading as="h2" mb={4} textAlign="center" color="teal.300">Items</Heading>
//             <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={6}>
//               {data.items.map(item => (
//                 <GridItem key={item._id}>
//                   <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={6} shadow="md">
//                     <Image src={`${Api}/${item.coverphoto.path}`} alt={item.name} borderRadius="md" />
//                     <Stack spacing={3} mt={3}>
//                       <Heading size="md" color="teal.200">{item.name}</Heading>
//                       <Text>{item.description}</Text>
//                       <Text>Start Price: {item.startPrice}</Text>
//                       <Text>Min Bid Increment: {item.minBidIncrement}</Text>
//                       <Badge colorScheme={item.status === 'active' ? 'green' : 'red'}>{item.status}</Badge>
//                       <Text>Bid Count: {item.bidCount}</Text>
//                       <Text>Bid User Count: {item.bidUserCount}</Text>
//                       <Text>Highest Bid: {item.highestBid}</Text>
//                       {/* {item.lastBid && (
//                         <Box>
//                           <Text>Last Bid: {item.lastBid.amount}</Text>
//                           <Text>Last Bid User: {item.lastBid.user.name}</Text>
//                           <Text>Last Bid User Phone: {item.lastBid.user.phoneNumber}</Text>
//                         </Box>
//                       )} */}
//                     </Stack>
//                   </Box>
//                 </GridItem>
//               ))}
//             </Grid>
//           </>
        
//       </Container>
//     </Box>
//   );
// };

// export default AuctionComponent;





import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { io } from 'socket.io-client';
import { Box, Flex, Spinner, Image, Text, Heading, Stack, Alert, AlertIcon, Grid, GridItem, Container, Badge } from '@chakra-ui/react';
import Api from '../../api/ApiUrl';

const SOCKET_URL = `${Api}/auctiondetails`;
const socket = io(SOCKET_URL, {
  autoConnect: false
});

const AuctionComponent = () => {
  const { id: subcategoryId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState('');

  const timerRef = useRef(null);

  const calculateTimeLeft = (endDate) => {
    const now = new Date().getTime();
    const endTime = new Date(endDate).getTime();
    const timeRemaining = endTime - now;

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
  };

  useEffect(() => {
    socket.on('connect', () => {
      socket.emit('getSubcategoryData', { subcategoryId });
    });

    socket.on('subCategoryDatachanged', () => {
      socket.emit('getSubcategoryData', { subcategoryId });
    });

    socket.on('auctionData', (data) => {
      setData(data);
      setLoading(false);

      calculateTimeLeft(data.endDate);

      timerRef.current = setInterval(() => {
        calculateTimeLeft(data.endDate);
      }, 1000);
    });

    socket.on('error', (error) => {
      setError(error);
      setLoading(false);
    });

    socket.connect();

    return () => {
      socket.disconnect();
      clearInterval(timerRef.current);
    };
  }, [subcategoryId]);

  if (loading) {
    return <Flex justify="center" align="center" height="100vh" bg="gray.800" color="white"><Spinner size="xl" /></Flex>;
  }

  if (error) {
    return <Alert status="error" bg="red.700" color="white"><AlertIcon />{error.message || 'Error loading data'}</Alert>;
  }

  if (!data) {
    return <Alert status="warning" bg="yellow.700" color="white"><AlertIcon />No data available</Alert>;
  }

  const isAuctionEnded = new Date() > new Date(data.endDate);

  return (
    <Box color="black" minHeight="100vh" py={10} position="relative" dir="rtl">
      {/* <Box position="absolute" top="40%" left="55%" transform="translate(-50%, -50%)" opacity="0.1" fontSize="10rem" fontWeight="bold" zIndex={0}>
        <Text as="span" color="red">Mazadat</Text><Text as="span" color="black"> Masr</Text>
      </Box> */}

      <Container maxW="container.xl" zIndex={1}>
        <Heading as="h1" mb={8} textAlign="center" color="teal.300">تفاصيل المزاد</Heading>
        <Grid justifyContent="center" alignItems="center" gap={6}>
          <Box mb={8} p={0} shadow="md" borderWidth="1px" borderRadius="lg" w={500}>
            <Image src={`${Api}/${data.imagecover.path}`} alt={data.name} borderRadius="md" w="100%"  />
            <Stack spacing={3} mt={3} dir="rtl" p={6}>
              <Text fontSize="2xl" mt={4} color="teal.200">{data.name}</Text>
              <Text mt={2}>{data.description}</Text>
              <Text fontSize="sm" mt={2}>تاريخ بدء المزاد: {new Date(data.startDate).toLocaleString()}</Text>
              <Text fontSize="sm" mt={2}>تاريخ انتهاء المزاد: {new Date(data.endDate).toLocaleString()}</Text>
                <>
                  <Text mt={2}>اجمالى عدد المزيدات: {data.totalBidCount}</Text>
                  <Text mt={2}>اجمالى عدد مدفوعات التامين: {data.totalDepositUsersCount}</Text>
                  <Text mt={2}>اجمالى عدد المزايدين الان: {data.totalBidUsersCount}</Text>
              {!isAuctionEnded && (
                  <Text mt={2}>الوقت المتبقي لانتهاء المزاد: {timeLeft}</Text>
                )} 
                </>
            </Stack>
          </Box>
        </Grid>

        <Heading as="h2" mb={4} textAlign="center" color="teal.300">تفاصيل اللوطات</Heading>
        <Grid templateColumns="repeat(4, minmax(300px, 1fr))" gap={6}>
          {data.items.map(item => {
            const isItemAuctionEnded = new Date() > new Date(data.endDate);
            const itemStatusText = isItemAuctionEnded ? 'Auction Ended' : item.status;
            const itemStatusColor = isItemAuctionEnded ? 'gray' : (item.status === 'active' ? 'green' : 'red');

            return (
              <GridItem key={item._id}>
                <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={0} shadow="md">
                  <Image src={`${Api}/${item.coverphoto.path}`} alt={item.name} borderRadius="md" />
                  <Stack spacing={3} mt={3} dir="rtl" p={6}>
                    <Heading size="md" color="teal.200">{item.name}</Heading>
                    <Text>{item.description}</Text>
                    <Text>سعر اللوط : {item.startPrice}</Text>
                    <Text>الحد الادني للمزايده : {item.minBidIncrement}</Text>
                    <Badge colorScheme={itemStatusColor}>{itemStatusText}</Badge>
                    <Text>عدد المزايدات :  {item.bidCount}</Text>
                    <Text>بتزايد الان عدد : {item.bidUserCount}</Text>
                    {/* <Text>Highest Bid: {item.highestBid}</Text> */}
                  </Stack>
                </Box>
              </GridItem>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default AuctionComponent;

